import { AddIcon, BackArrow, TagsIcon } from "allIcons";
import {
  useDeleteGlossaryCategory,
  useGetGlossaryCategory,
  useGlosssary,
} from "api/templateLibrary/glossary";
import {
  BodyContainer,
  HeaderContainer,
  IconWrapper,
  ListCard,
  ListIconWrapper,
  Loader,
  LoadingListCards,
  MainButton,
  PrimaryHeading,
  RightMainContainer,
  TemplateNotFound,
} from "commonUI";
import { ModulePrefixes } from "enums";
import { isEqual } from "helpers";
import { useUserPermissions } from "hooks/user";
import { t } from "i18next";
import { Link, useNavigate } from "react-router-dom";

export default function GlossaryCategories() {
  const navigate = useNavigate();
  const { data: categories, isLoading } = useGetGlossaryCategory();
  const { add_new_templates, edit_templates, delete_templates } =
    useUserPermissions();
  const { mutate: deleteCategory, isLoading: deletingCategory } =
    useDeleteGlossaryCategory();
  const { data: glossary } = useGlosssary();
  return (
    <>
      <RightMainContainer>
        <Loader show={deletingCategory} loader="block" />
        <HeaderContainer>
          <IconWrapper>
            <BackArrow onClick={() => navigate(`/${ModulePrefixes.TEMPLATE_LIBRARY}/glossary`)} />
            <PrimaryHeading>
              {t("libraryTemplate.glossaryCategories.title")}
            </PrimaryHeading>
          </IconWrapper>
          {add_new_templates ? (
            <Link to="add">
              <MainButton>
                <AddIcon />
                {t("button.add")}
              </MainButton>
            </Link>
          ) : (
            ""
          )}
        </HeaderContainer>
        <BodyContainer>
          {isLoading ? (
            <LoadingListCards />
          ) : categories.length === 0 ? (
            <TemplateNotFound
              label={t("libraryTemplate.glossaryCategories.category")}
              link={add_new_templates ? "add" : ""}
              linkLabel={t("libraryTemplate.glossaryCategories.category")}
            />
          ) : (
            categories.map((ele) => (
              <ListCard
                data={ele.title}
                icon={
                  <ListIconWrapper>
                    <TagsIcon />
                  </ListIconWrapper>
                }
                editIcon={edit_templates}
                link={
                  edit_templates
                    ? `/${ModulePrefixes.TEMPLATE_LIBRARY}/glossary/categories/${ele.id}`
                    : ""
                }
                showDeleteResult={true}
                deleteResponseMessage={t(
                  "libraryTemplate.glossaryCategories.delete.failed.message"
                )}
                deleteResponseTitle={t(
                 "libraryTemplate.glossaryCategories.delete.failed.title"
                )}
                strictLink={true}
                deleteIcon={!delete_templates}
                onDelete={() => {
                  if (glossary?.some((_) => isEqual(_.category_id, ele.id))) {
                    return false;
                  }
                  deleteCategory(ele.id);
                  return true
                }}
                deleteTitle={t("libraryTemplate.delete.title")}
                deleteButtonText={t("libraryTemplate.delete.button")}
                deleteMessage={t("libraryTemplate.delete.message")}
              />
            ))
          )}
        </BodyContainer>
      </RightMainContainer>
    </>
  );
}
